import i18next from "i18next";
import React, { ReactElement } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { Action, Case } from "../interfaces/ReducerCase";
import { language } from "../stores/18nStore";
import "../styles/legal-footer.scss";

/**
 * Legal mentions row displayed at the bottom of the logged-in browsing views.
 *
 * Mirrors what article 7.6 of the CGU promises: the consent choice "peut être
 * modifié à tout moment depuis le lien Gestion des cookies en bas de page".
 * Resetting isTCValidated to null re-opens the consent modal straight on its
 * settings panel (see UseCookies, which initialises isSettings from that null).
 */
export default function LegalFooter(): ReactElement {
  const dispatch: Dispatch<Action> = useDispatch();
  const currentYear = new Date().getFullYear();

  const reopenCookiesSettings = () => {
    dispatch({ type: Case.SET_TC, payload: { choices: null } });
    localStorage.setItem("isTCValidated", JSON.stringify(null));
  };

  return (
    <div className="legal-footer">
      <div className="legal-footer-links">
        <a href={`https://sybel.co/${i18next.language.substr(0, 2)}/cgu/`}>
          {language("tc")}
        </a>
        <p className="legal-footer-cookies" onClick={reopenCookiesSettings}>
          {language("manageCookies")}
        </p>
      </div>
      <p className="legal-footer-copyright">© Sybel {currentYear}</p>
    </div>
  );
}
